import { message } from 'antd';
import { CloseOutlined, CheckOutlined, EyeOutlined } from '@ant-design/icons';

import styles from './stylesViewDetailsModal.module.css';

import moneyFormatter from '../../../../utils/MoneyFormatter';
import { useWithdrawalReview } from '../WithdrawalReviewContext';
import { convertToUserTimezone } from '../../../../utils/FormatDate';

const blacklist = ["'s checking", "'s savings"];

function ViewDetailsModal() {
  const {
    selectedTab,
    userDetails,
    setIsDetailsModalOpen,
    handleViewUser,
    handleApproved,
    openDeclinedModal,
  } = useWithdrawalReview();

  const handleClose = () => {
    setIsDetailsModalOpen(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'declined':
      case 'cancelled':
        return styles.red;
      default:
        return styles.green;
    }
  };

  const cleanKycName = (name) => {
    let result = name.toLowerCase();
    blacklist.forEach((word) => {
      const regex = new RegExp(word, 'gi');
      result = result.replace(regex, '');
    });
    return result.trim();
  };

  const handleApprovedRequest = (record) => {
    handleApproved(record);
    handleClose();
    message.success('Withdrawal Approved');
  };

  const handleDeclineRequest = (record) => {
    handleClose();
    openDeclinedModal(record);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <h2>Withdrawal Transaction</h2>
        </div>
        <CloseOutlined onClick={handleClose} className={styles.closeIcon} />
      </div>

      <div className={styles.content}>
        <div className={styles.details}>
          <span className={styles.label}>Request Date</span>
          <span>
            {convertToUserTimezone(userDetails?.request_date_timestamp)}
          </span>
        </div>
        {selectedTab === 'PROCESSED' && (
          <div className={styles.details}>
            <span className={styles.label}>Processed Date</span>
            <span>{convertToUserTimezone(userDetails?.reviewed_at)}</span>
          </div>
        )}

        <div className={styles.details}>
          <span className={styles.label}>User name</span>
          <span>{userDetails?.username}</span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Transaction ID</span>
          <span style={{ maxWidth: 250 }}>{userDetails?.transaction_id}</span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Last Deposit Amount</span>
          <span>${moneyFormatter(userDetails?.last_deposit_amount)}</span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Withdrawal Amount</span>
          <span>${moneyFormatter(userDetails?.withdrawal_amount)}</span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Payment Gateway</span>
          <span>{userDetails?.payment_gateway}</span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Status</span>
          {selectedTab === 'PENDING' ? (
            <span className={`${styles.status} ${styles.orange}`}>Pending</span>
          ) : (
            <span
              className={`${styles.status} ${getStatusColor(
                userDetails?.transaction_status?.toLowerCase()
              )}`}
            >
              {userDetails?.transaction_status}
            </span>
          )}
        </div>
        <div className={styles.details}>
          <span className={styles.label}>KYC Name</span>
          <span>
            {cleanKycName(userDetails?.kyc_cardholder_name)?.toUpperCase()}
          </span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Cardholder's name</span>
          <span>{userDetails?.full_name?.toUpperCase()}</span>
        </div>
        <div className={styles.details}>
          <span className={styles.label}>Card number</span>
          <span>**** **** **** {userDetails?.card_last_four}</span>
        </div>

        {selectedTab === 'PROCESSED' && (
          <div className={styles.details}>
            <span className={styles.label}>Processed By</span>
            <span>{userDetails?.reviewed_by}</span>
          </div>
        )}

        {selectedTab === 'PROCESSED' &&
          userDetails.transaction_status === 'declined' && (
            <div className={styles.warningContainer}>
              <p>{userDetails.review_notes}</p>
            </div>
          )}
      </div>

      <div className={styles.divider} />

      <div className={styles.footer}>
        {selectedTab === 'PENDING' ? (
          <div className={styles.buttons}>
            <button
              className={`${styles.button} ${styles.acceptButton}`}
              onClick={() => handleApprovedRequest(userDetails)}
            >
              <CheckOutlined />
              <span>Accept</span>
            </button>
            <button
              className={`${styles.button} ${styles.declineButton}`}
              onClick={() => handleDeclineRequest(userDetails)}
            >
              <CloseOutlined />
              <span>Decline</span>
            </button>
          </div>
        ) : (
          <div className={styles.closeButton}>
            <button onClick={handleClose}>
              <span>Close</span>
            </button>
          </div>
        )}
        <div className={styles.checkUserContainer}>
          <button onClick={() => handleViewUser(userDetails)}>
            <EyeOutlined style={{ marginRight: 6 }} />
            <span>Check User's Profile</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewDetailsModal;
